import { detectFormat } from './detect'
import { ConversionError } from './errors'
import { FORMATTERS } from './formatters'
import {
  type ParseStats,
  type SourceFormat,
  type TargetFormat,
  emptyStats,
} from './models'
import { PARSERS } from './parsers'

export type ConvertOptions = {
  input: string
  toFormat: TargetFormat
  fromFormat?: SourceFormat
  onProgress?: (msg: string) => void
}

export type ConvertResult = {
  output: string
  stats: ParseStats
  detectedFormat: SourceFormat
}

export async function convert(opts: ConvertOptions): Promise<ConvertResult> {
  const log = opts.onProgress ?? (() => undefined)

  const input = opts.input.replace(/\r\n/g, '\n').replace(/\r/g, '\n')

  const fromFormat = opts.fromFormat ?? detectFormat(input)
  log(`Detected format: ${fromFormat}`)

  const parser = PARSERS[fromFormat]
  const formatter = FORMATTERS[opts.toFormat]

  const records = parser.splitRecords(input)
  const stats: ParseStats = emptyStats()
  stats.total = records.length

  const lines: string[] = []
  for (let i = 0; i < records.length; i++) {
    try {
      const account = parser.parse(records[i])
      const line = formatter(account)
      lines.push(line)
      stats.success++
      log(`✅ Record ${i + 1}: Successfully (${account.login})`)
    } catch (e) {
      stats.errors++
      const message = e instanceof ConversionError ? e.message : `Unexpected error: ${(e as Error).message}`
      stats.errorDetails.push({ index: i + 1, message })
      log(`❌ Record ${i + 1}: ${message}`)
    }
  }

  const output = lines.length > 0 ? lines.join('\n') + '\n' : ''
  return { output, stats, detectedFormat: fromFormat }
}
